export default __webpack_public_path__ + "static/media/Campaign.fd091742.svg";